import { reactive, ref, useRoute, useRouter, computed, nextTick, useStore, watch } from "@nuxtjs/composition-api";
import { isEqual, pick, uniqueId, isEmpty } from "lodash";
import { REQUEST_CODES } from "~/constants/const-http";
import { getAisCruiseList } from "~/services/company";
// import TwoWayBindingWrapper from "~/utils/two-way-binding-wrapper";
// import useWatchPrimitiveProperties from "../useWatchPrimitiveProperties";

function getDefaultSearchData() {
    return {
        class_id: [],
        tonnage: [],
        navistatus: [],
        renovation_time_start: '',
        renovation_time_end: '',
        first_flight_time_start: '',
        first_flight_time_end: '',
        company_id: [],
        keyword: ''
    }
}
function useQuery() {
    const searchData = ref(getDefaultSearchData());
    const searchKeys = Object.keys(searchData.value)
    const router = useRouter();
    const route = useRoute();

    watch(() => route.value.query, (query) => {
        const defaultValues = pick(query, searchKeys);
        if (!isEqual({...searchData.value, ...defaultValues}, searchData.value)) {
            Object.assign(searchData.value, defaultValues);
        }
    }, {
        immediate: true
    })

    return {
        searchData,
        isDefaultState: computed(() => isEqual(getDefaultSearchData(), searchData.value)),
        setSearchData: (value = {}) => {
            const query = route.value.query;
            const newValue = {
                ...route.value.query,
                ...value
            }
            // console.log(isEqual(query, newValue), query, newValue)
            if (!isEqual(query, newValue)) {
                return router.replace({
                    query: {
                        ...newValue
                    }
                })
            }
        }
    }
}



export default function useCruiseList() {
    const { searchData, setSearchData, isDefaultState } = useQuery()

    const identifier = ref(uniqueId('infinite-'));
    const store = useStore();
    async function onConfirm(state = {}) {
        await setSearchData(Object.assign({}, searchData.value, state))
        resetPage();
    }
    const cruisePagination = reactive({
        page_index: 1,
        page_size: 10,
        total_page: 1
    });
    const asiCruises = ref([]);
    const total = reactive({
        cruise: 0,
        company: 0
    })


  


    async function onLoadCruiseList($state) {
        try {
            if (asiCruises.value.length) {
                cruisePagination.page_index += 1;
            }
            const { list, cruise_company_num, cruise_num, ...pages } = await fetchCruiseList();
            Object.assign(total, {
                cruise: cruise_num,
                company: cruise_company_num
            })
            if (list.length) {
                asiCruises.value = asiCruises.value.concat(list);
                Object.assign(cruisePagination, {
                    page_index: pages.page_index,
                    page_size: pages.page_size,
                    total_page: pages.total_page
                });

                $state.loaded();
            }
            if (pages.page_index >= pages.total_page) {
                $state.complete();
            }
        } catch (error) {
            console.error(error);
            $state.error();
        }
    }
    function transformSearchParams(searchData) {
        return {
            ...searchData,
            tonnage: searchData.tonnage.map((item) => {
                const [min, max] = item.split('-')
                return { min, max }
            })
        }
    }
    async function fetchCruiseList() {
        const { code, data, msg } = await getAisCruiseList({
            page_index: cruisePagination.page_index,
            page_size: cruisePagination.page_size,
            ...transformSearchParams(searchData.value)
        });

        if (code !== REQUEST_CODES.ERROR_OK) {
            throw new Error(msg);
        }

        return data;
    }

    async function resetPage() {
        asiCruises.value = [];

        Object.assign(cruisePagination, {
            page_index: 1, page_size: 10, total_page: 1
        })
        await nextTick();
        identifier.value = uniqueId('infinite-');
    }

    async function onResetFilter() {
        await setSearchData({
            class_id: [],
            tonnage: [],
            navistatus: [],
            renovation_time_start: '',
            renovation_time_end: '',
            first_flight_time_start: '',
            first_flight_time_end: '',
            company_id: [],
            keyword: ''
        })
        resetPage();
        // nextTick(() => store.dispatch("cruiseMap/fetchAisCruises", transformSearchParams(searchData.value)));
    }
    const searchParams = computed(() => ({
        ...searchData.value,
        tonnage: searchData.value.tonnage.map((item) => {
            const [min, max] = item.split('-')
            return { min, max }
        })
    }))
    const hasSearch = computed(() => {
        return Object.values(searchParams.value).some(v => !isEmpty(v))
    })
    
    return {
        onLoadCruiseList,
        asiCruises,
        total,
        onConfirm,
        searchData,
        identifier,
        onResetFilter,
        transformSearchParams,
        searchParams,
        isDefaultState,

        hasSearch
    }
}